import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import type { Role } from "@/queries/adminUsers";

interface RoleBadgeProps {
  role: Role;
}

export function RoleBadge({ role }: RoleBadgeProps) {
  const { t } = useTranslation("admin-users");
  if (role === "admin") {
    return <Badge variant="default">{t("badges.admin")}</Badge>;
  }
  return <Badge variant="muted">{t("badges.user")}</Badge>;
}
